export enum MenuType {
  PAGES,
  ADMIN_PAGES,
  INFO_PAGES,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/menu-type.enum.ts